export function popups() {
    const mainWrap = $("html");
    const popupWrap = $(".popups");
    const popupLink = $(".popup-link");
    const popup = $(".popup");
    const popupClose = popup.find(".popup-close");

    popupLink.on("click", function () {
        mainWrap.addClass("popup-is-open");
    });
    popupWrap.on("click", function (event) {
        if (!$(event.target).closest(".popup").length > 0) {
            mainWrap.removeClass("popup-is-open");
        }
    });
    popupClose.on("click", function () {
        mainWrap.removeClass("popup-is-open");
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/popups.js